import { Button, Dropdown, Menu } from "antd"
import { Copy01Icon, Delete03Icon, PencilEdit02Icon } from "components-old/icons"
import MenuLink from "components-old/menu/MenuLink"
import { TablePageRouterProps } from "./TablePageRouter"
import Separator from "components/navigation/Separator"
import { showDeleteModalConfirm } from "lib/utils"

export const getTableActionsColumn = (props: {
  routeBase
  rowActions: TablePageRouterProps<any>["rowActions"]
  updateLocal
  remove
  removeLocal
}) => {
  const { updateLocal, remove, removeLocal } = props
  return {
    id: "actions-column",
    enablePinning: true,
    maxSize: 56,
    size: 56,
    cell: (info) => {
      const rowId = info?.row.original?.id

      const hideRemove =
        typeof props.rowActions?.hideRemove === "function" ? props.rowActions?.hideRemove(info?.row.original) : props.rowActions?.hideRemove
      const hideClone =
        typeof props.rowActions?.hideClone === "function" ? props.rowActions?.hideClone(info?.row.original) : props.rowActions?.hideClone

      return (
        <div className="absolute right-2.5 g-table-actions-column">
          <Dropdown
            overlay={
              <Menu
                onClick={(e) => {
                  e.domEvent.stopPropagation()
                }}
              >
                {!props.rowActions?.hideEdit && (
                  <Menu.Item key="edit">
                    <MenuLink
                      icon={
                        <i>
                          <PencilEdit02Icon />
                        </i>
                      }
                      to={`${props.routeBase}/${rowId}`}
                    >
                      Editar
                    </MenuLink>
                  </Menu.Item>
                )}
                {hideClone !== true && (
                  <Menu.Item key="clone">
                    <MenuLink
                      icon={
                        <i>
                          <Copy01Icon />
                        </i>
                      }
                      to={`${props.routeBase}/new?cloneFromId=${rowId}`}
                    >
                      Clonar
                    </MenuLink>
                  </Menu.Item>
                )}
                {hideRemove !== true && <Separator />}
                {/* {props.getExtraActions?.(info?.row.original)?.map(option => ) && <Separator />} */}
                {props.rowActions?.getExtraActions?.(info?.row.original, { updateLocal })}
                {props.rowActions?.getExtraActions && !hideRemove && <Separator />}
                {hideRemove !== true && (
                  <Menu.Item
                    key="remove"
                    icon={
                      <i>
                        <Delete03Icon />
                      </i>
                    }
                    onClick={() => {
                      if (props.rowActions?.removeOnClick) {
                        props.rowActions.removeOnClick(() => remove({ id: rowId }).then(() => removeLocal(rowId!)), info?.row.original)
                      } else {
                        showDeleteModalConfirm({
                          description: props.rowActions?.removeDescription || "Tem certeza que deseja excluir?",
                          onConfirm: () => remove({ id: rowId }).then(() => removeLocal(rowId!)),
                        })
                      }
                    }}
                  >
                    Excluir
                  </Menu.Item>
                )}
              </Menu>
            }
            trigger={["click"]}
            className={""}
          >
            <Button
              icon={<i className={"fal fa-ellipsis"} style={{ fontSize: 22 }} />}
              type="text"
              onClick={(e) => {
                e.stopPropagation()
              }}
              className="ml-auto hover:bg-base-400 focus-within:bg-base-400 rounded-xl invisible group-hover/grid:visible  group-hover/grid:focus-within:visible mobile:visible [tr:hover_&]:visible [tr:focus-within_&]:visible"
            />
          </Dropdown>
        </div>
      )
    },
  }
}
